import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { withRouter } from "react-router";

import NavBar from "../components/NavBar";
import "./Login.css";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <div className="background">
        <NavBar />
        <Container maxWidth="md" style={{ marginTop: "0px" }}>
          <Typography
            variant="h5"
            gutterBottom
            className="loginTitle"
            style={{ textAlign: "center" }}
          >
            Terms of Service
          </Typography>

          <div className="terms-content">
            <div className="paragraph">
              <p>
                The following terms and conditions govern all use of the
                VideoViews website (“the Website”). The Website is offered
                subject to your acceptance without modification of all of the
                terms and conditions contained herein and all other operating
                rules, policies (including, without limitation, VideoViews’s
                Privacy Policies​ ) and procedures that may be published from
                time to time on this Site by VideoViews (collectively, the
                “Agreement”).
                <br />
                Please read this Agreement carefully before accessing or using
                the Website. By accessing or using any part of the Website, you
                agree to become bound by the terms and conditions of this
                agreement. If you do not agree to all the terms and conditions
                of this agreement, then you may not access the Website or use
                any of it services. ​ By using VideoViews, you confirm that:
                <br />
                <span className="list-level-1">
                  <b>A.</b>​You will only use VideoViews for business and
                  professional reasons;
                </span>
                <br />
                <span className="list-level-1">
                  <b>B.</b>​​You are at least 18 years old or otherwise able to
                  enter into a legally binding agreement;
                </span>
                <br />
                <span className="list-level-1">
                  <b>C.</b>​You accept and will comply with this Agreement;
                </span>
                <br />
                <span className="list-level-1">
                  <b>D.</b>​If you are using VideoViews as a representative of
                  an organization, you have the power to enter into legally
                  binding agreements for that organization; and
                </span>
                <br />
                <span className="list-level-1">
                  <b>E.</b>​​You are responsible for anyone that uses VideoViews
                  through your account, such as your employees, consultants or
                  contractors (“Authorized Users”).
                </span>
              </p>

              <p>
                <b>Terms of Use</b>
              </p>
              <p>
                <b>1. Access to your VideoViews Account. </b> Subject to the
                terms and conditions of this Agreement, the Service is solely
                for User’s use. As used herein, “User” includes VideoViews’s
                paying customers (“Customers”). This Agreement sets forth
                certain terms and conditions that apply to Customers, but not
                other Users. In the event any Customer-specific terms or
                conditions conflict with any of the terms or conditions that
                apply to Users generally, the Customer-specific terms/conditions
                shall control.
                <br />
                VideoViews may change, suspend or discontinue the Services at
                any time, including the availability of any feature, database,
                or content. VideoViews may also impose limits on certain
                features and services or restrict User’s access to parts or all
                of the Services without notice or liability; including prepaid
                licences.
                <br />
                User certifies to VideoViews that if User is an individual
                (i.e., not a corporation) User is at ​ least 18 years old or
                otherwise able to enter into a legally binding agreement​ . User
                also certifies that it is legally permitted to use the Service,
                and takes full responsibility for the selection and use of the
                the Service. This Agreement is void where prohibited by law, and
                the right to access the Service is revoked in such
                jurisdictions.
                <br />
                User shall be responsible for obtaining and maintaining any
                equipment or ancillary services needed to connect to, access the
                Service, including, without limitation, modems, hardware,
                software, and long distance or local telephone service. User
                shall be responsible for ensuring that such equipment or
                ancillary services are compatible with the Service.
              </p>
              <p>
                <b>2. Restrictions. </b> User shall not, nor permit anyone else
                to, directly or indirectly: (i) reverse engineer, disassemble,
                decompile or otherwise attempt to discover the source code or
                underlying algorithms of all or any part of the Service (except
                that this restriction shall not apply to the limited extent
                restrictions on reverse engineering are prohibited by applicable
                local law); (ii) modify or create derivatives of any part of the
                Service; (iii) rent, lease, or use the Service for time sharing
                or service bureau purposes; or (iv) remove or obscure any
                proprietary notices on the Service. As between the parties,
                Company shall own all title, ownership rights, and intellectual
                property rights in and to the Service, and any copies or
                portions thereof. User shall not use any “deep-link”,
                “page-scrape”, “robot”, “spider” or other automatic device,
                program, algorithm or methodology, or any similar or equivalent
                manual process, to access, acquire, copy or monitor any portion
                of the Service or any Content, or in any way reproduce or
                circumvent the navigational structure or presentation of the
                Service or any Content, to obtain or attempt to obtain any
                materials, documents or information through any means not
                purposely made available through the Service. VideoViews
                reserves the right to bar any such activity.
                <br />
                User shall not attempt to gain unauthorised access to any
                portion or feature of the Service, or any other systems or
                networks connected to the Service or to any VideoViews server,
                or to any of the services offered on or through the Service, by
                hacking, password “mining”, or any other illegitimate means.
                <br />
                User shall not probe, scan or test the vulnerability of the
                Service or any network connected to the Service, nor breach the
                security or authentication measures on the Service or any
                network connected to the Service.
                <br />
                User shall not take any action that imposes an unreasonable or
                disproportionately large load on the infrastructure of the
                Service or VideoViews’s systems or networks, or any systems or
                networks connected to the Service or to VideoViews.
                <br />
                User shall not use any device, software or routine to interfere
                or attempt to interfere with the proper working of the Service
                or any transaction being conducted on the Service, or with any
                other person’s use of the Service.
                <br />
                User shall not use the Service or any Content for any purpose
                that is unlawful or prohibited by this Agreement.
              </p>
              <p>
                <b>3. Fees and Payment. </b>
                VideoViews functionality is a premium paid service available on
                the Website. By selecting a premium service you agree to pay
                VideoViews the pay-per-use, monthly or annual subscription fees
                indicated for that service. Payments will be charged on the day
                you sign up for a premium service and will cover the use of that
                service for a monthly or annual period as indicated.
                <br />
                You can cancel your plan at any time and will have full access
                until the end of your current paid period. Full and partial
                refunds will not be issued for premium service fees, including
                if cancelled in the following situations:
                <br />
                <span className="list-level-1">
                  a. the service is no longer required;
                </span>
                <br />
                <span className="list-level-1">b. accidental purchase;</span>
                <br />
                <span className="list-level-1">
                  c. the service was forgotten about;
                </span>
                <br />
                <span className="list-level-1">d. service downtime;</span>
                <br />
                <span className="list-level-1">e. request for goodwill.</span>
                <br />
                The inclusion of a free trial is complimentary at the beginning
                of a subscription. The full agreed fees will be charged on
                completion of the free trial period unless cancelled in advance.
                Should payments for annual subscriptions fail to be charged on
                three occasions, such subscription packages will be dropped to
                monthly billing to ensure continuity of service.
              </p>
              <p>
                <b>4. Registration. </b>
                As a condition to using certain products and services of the
                Service, User may be required to register with VideoViews and
                select a password. User shall provide VideoViews with accurate,
                complete, and updated registration information. Failure to do so
                shall constitute a breach of this Agreement, which may result in
                immediate termination of User’s account. VideoViews reserves the
                right to refuse registration of, or cancel a VideoViews User in
                its discretion. User shall be responsible for maintaining the
                confidentiality of User’s VideoViews password and other account
                information.
              </p>
              <p>
                <b>5. Termination. </b>
                VideoViews may terminate your access to all or any part of the
                Website at any time, with or without cause, with or without
                notice, effective immediately. If you wish to terminate this
                Agreement or your VideoViews account (if you have one), you may
                simply discontinue using the Website. Notwithstanding the
                foregoing, if you have a paid account, such account can only be
                terminated by VideoViews if you materially breach this Agreement
                and fail to cure such breach within thirty (30) days from
                VideoViews’s notice to you thereof; provided that, VideoViews
                can terminate the Website immediately at any time as part of a
                general shut down of our service.
                <br />
                All provisions of this Agreement which by their nature should
                survive termination shall survive termination, including,
                without limitation, ownership provisions, warranty disclaimers,
                indemnity and limitations of liability.
              </p>
              <p>
                <b>6. Content. </b>
                User agrees that all content and materials (collectively,
                “Content”) delivered via the Service or otherwise made available
                by VideoViews at the Site are protected by copyrights,
                trademarks, service marks, patents, trade secrets or other
                proprietary rights and laws. VideoViews does not support the
                distribution of pornographic, hate or unlawful content. Except
                as expressly authorized by VideoViews in writing, User agrees
                not to sell, license, rent, modify, distribute, copy, reproduce,
                transmit, publicly display, publicly perform, publish, adapt,
                edit or create derivative works from such materials or content.
              </p>
              <p>
                <b>7. Changes. </b>
                VideoViews reserves the right, at its sole discretion, to modify
                or replace any part of this Agreement. It is your responsibility
                to check this Agreement periodically for changes. Your continued
                use of or access to the Website following the posting of any
                changes to this Agreement constitutes acceptance of those
                changes. VideoViews may also, in the future, offer new services
                and/or features through the Website (including, the release of
                new tools and resources). Such new features and/or services
                shall be subject to the terms and conditions of this Agreement.
              </p>
              <p>
                <b>8. Warranties. </b>
                If User is a Customer, VideoViews makes the following warranty
                to Customer: VideoViews shall use commercially reasonable
                efforts consistent with prevailing industry standards to provide
                the services in a professional and workmanlike manner that is
                free of defects. Customer’s sole remedy, and VideoViews’s
                exclusive liability, for defects in the Service shall be for
                VideoViews to use commercially reasonable efforts to promptly
                correct such defects.
                <br />
                Customer represents and warrants that: (i) with respect to all
                information it provides to VideoViews (such as, Recipient
                Information), Customer has the full right and authority to make
                such provision and to allow VideoViews to use such information
                to provide the Service (including, without limitation, for
                VideoViews to provide such information to its data providers),
                (ii) none of the content (e.g. emails) transmitted, uploaded or
                otherwise distributed by it (or its partners or any third party)
                through use of the Service will infringe or otherwise conflict
                with the rights of any third party.
              </p>
              <p>
                <b>9. Warranty Disclaimer.</b>
                The Website is provided “as is”. VideoViews and its suppliers
                and licensors hereby disclaim all warranties of any kind,
                express or implied, including, without limitation, the
                warranties of merchantability, fitness for a particular purpose
                and non-infringement. Neither VideoViews nor its suppliers and
                licensors, makes any warranty that the Website will be error
                free or that access thereto will be continuous or uninterrupted.
                You understand that you download from, or otherwise obtain
                content or services through, the Website at your own discretion
                and risk. VideoViews is not responsible or liable for any impact
                or changes to any third party accounts, memberships, profiles or
                subscriptions as a result of becoming a customer of VideoViews.
              </p>
              <p>
                <b>10. Security.</b>
                In no event will VideoViews, or its suppliers or licensors, be
                liable with respect to any subject matter of this agreement
                under any contract, negligence, strict liability or other legal
                or equitable theory for: (i) any special, incidental or
                consequential damages; (ii) the cost of procurement or
                substitute products or services; (iii) for interruption of use
                or loss or corruption of data; or (iv) for any amounts that
                exceed the fees paid by you to VideoViews under this agreement
                during the twelve (12) month period prior to the cause of
                action. VideoViews shall have no liability for any failure or
                delay due to matters beyond their reasonable control. The
                foregoing shall not apply to the extent prohibited by applicable
                law.
              </p>
              <p>
                <b>11. General Representation and Warranty.</b>
                You represent and warrant that (i) your use of the Website will
                be in strict accordance with the VideoViews Privacy Policy, with
                this Agreement and with all applicable laws and regulations
                (including without limitation any local laws or regulations in
                your country, state, city, or other governmental area, regarding
                online conduct and acceptable content, and including all
                applicable laws regarding the transmission of technical data
                exported from Canada or the country in which you reside) and
                (ii) your use of the Website will not infringe or misappropriate
                the intellectual property rights of any third party.
              </p>
              <p>
                <b>12. Privacy.</b>
                VideoViews’s current privacy policy is available at the Site
                (the “Privacy Policy”), which is incorporated by this reference.
                VideoViews strongly recommends that you review the Privacy
                Policy closely.
              </p>
              <p>
                <b>13. Intellectual Property.</b>
                All content included on the Site, such as text, graphics, logos,
                button icons, images, audio clips, digital downloads, data
                compilations, and software, is the property of MoreIdeas Inc.
                (dba envision.ai) or its content suppliers and protected by
                Canadian, United States and international copyright laws. The
                compilation of all content on the Site is the exclusive property
                of MoreIdeas Inc. (dba envision.ai) and VideoViews and protected
                by Canadian, United States and international copyright laws. All
                software used on (or provided through) the Site is the property
                of MoreIdeas Inc. (dba envision.ai) and VideoViews or its
                software suppliers and protected by Canadian, United States and
                international copyright laws.
              </p>
              <p>
                <b>14. Indemnification.</b>
                You agree to indemnify and hold harmless MoreIdeas Inc. (dba
                envision.ai) and VideoViews, its contractors, and its licensors,
                and their respective directors, officers, employees and agents
                from and against any and all claims and expenses, including
                attorneys’ fees, arising out of your use of the Website,
                including but not limited to out of your violation this
                Agreement.
              </p>
              <p>
                <b>15. ​ Governing Law.</b>
                This Agreement will be interpreted, construed, and enforced in
                all respects in accordance with the laws of the Province of
                Quebec without reference to its choice of law rules. No party
                hereto shall commence or prosecute any suit, proceeding, or
                claim to enforce the provisions of this Agreement, to recover
                damages or other relief for breach of or default under this
                Agreement, other than in the Superior Court of the District of
                Montreal. Each of the parties hereto irrevocably consents to the
                personal jurisdiction and venue of the courts identified in the
                preceding sentence.
              </p>
              <p>
                <b>16. Language.</b>
                This document has been written in the English language at the
                specific request of both parties. Ce document a été rédigé en
                langue anglaise à la demande expresse des deux parties.
              </p>
            </div>
          </div>
        </Container>
      </div>
    );
  }
}

export default withRouter(Index);
